var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1892 7.67557V13.2406M22.8678 7.67552V13.2405M9.23923 21.3609H3.3335M36.6668 21.361H30.7611M4.01495 29.7084L8.44425 26.8691M36.0422 29.7083L31.6129 26.869M20.0285 32.6046V27.3916M22.9814 23.9163V24.0866C22.9814 25.7488 21.634 27.0963 19.9718 27.0963C18.3096 27.0963 16.9621 25.7488 16.9621 24.0866V23.9163M3.56061 7.61874L3.79292 11.9663C3.89589 13.8933 4.97051 15.6362 6.64605 16.5937L6.74062 16.6477C5.77526 21.9666 7.29712 32.6045 19.9717 32.6045C32.6464 32.6045 34.1682 21.9666 33.2029 16.6477L33.2974 16.5937C34.973 15.6362 36.0476 13.8933 36.1506 11.9663L36.3829 7.61874C34.49 7.44838 30.1932 7.59602 28.1489 9.54946C27.1646 8.83017 24.1512 7.3916 19.9717 7.3916C15.7923 7.3916 12.7789 8.83017 11.7946 9.54946C9.75028 7.59602 5.45347 7.44838 3.56061 7.61874Z",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8168 19.0583C15.8168 19.5093 15.4512 19.8749 15.0002 19.8749C14.5491 19.8749 14.1835 19.5093 14.1835 19.0583C14.1835 18.6072 14.5491 18.2416 15.0002 18.2416C15.4512 18.2416 15.8168 18.6072 15.8168 19.0583ZM25.8168 19.0583C25.8168 19.5093 25.4512 19.8749 25.0002 19.8749C24.5491 19.8749 24.1835 19.5093 24.1835 19.0583C24.1835 18.6072 24.5491 18.2416 25.0002 18.2416C25.4512 18.2416 25.8168 18.6072 25.8168 19.0583Z",
    stroke: "#323232",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/Cat.cdd65111b3bc2e56f353f661c7f6967a.svg";
export { ForwardRef as ReactComponent };